var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardGalleryArrowIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Arrow icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.900000036
  }, /*#__PURE__*/React.createElement("g", {
    id: "new-serp",
    transform: "translate(-434.000000, -358.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5438-Copy-31",
    transform: "translate(450.000000, 374.000000) scale(-1, 1) rotate(90.000000) translate(-450.000000, -374.000000) translate(434.000000, 358.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5438",
    transform: "translate(16.000000, 16.001000) rotate(-90.000000) translate(-16.000000, -16.001000) translate(0.000000, 0.001000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5437",
    transform: "translate(16.000000, 16.000000) rotate(90.000000) translate(-16.000000, -16.000000) translate(4.000000, 4.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C5.372583,0 0,5.372583 0,12 C0,18.627417 5.372583,24 12,24 C18.627417,24 24,18.627417 24,12 C24,8.81740212 22.7357179,5.76515517 20.4852814,3.51471863 C18.2348448,1.26428208 15.1825979,0 12,0 Z",
    id: "iconmonstr-arrow-28",
    fillOpacity: 0.9,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67851755,14.8043486 C8.15334649,14.7859215 7.73712807,14.3548428 7.73712807,13.8293486 C7.73712807,13.3038543 8.15334649,12.8727756 8.67851755,12.8543486 L14.0461175,12.8543486 L14.0461175,7.50714858 C14.0461175,6.96867095 14.4826399,6.53214858 15.0211175,6.53214858 C15.5595952,6.53214858 15.9961175,6.96867095 15.9961175,7.50714858 L15.9961175,13.8071486 C15.9782338,14.3579461 15.5307467,14.7975084 14.9797175,14.8055486 L8.67851755,14.8043486 Z",
    id: "union",
    fill: "#2A2E43",
    transform: "translate(11.866623, 10.668849) rotate(45.000000) translate(-11.866623, -10.668849) "
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    transform: "translate(16.000000, 16.000000) rotate(90.000000) translate(-16.000000, -16.000000) ",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardGalleryArrowIcon);
export default __webpack_public_path__ + "static/media/CardGalleryArrowIcon.3bca119ac96495c0c4aedea911104661.svg";
export { ForwardRef as ReactComponent };